import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Space, Switch, Table } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import formatDateTime from "utils/formatter/formatDateTime";
import { useSelector } from "react-redux";
import TableAntd from "components/elements/Table/Table";
const SkillTypeTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onDelete = () => { },
  onStatus = () => { },
  onChange = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    if (i18n.language === "en") {
      return date.format("DD/MM/YYYY HH:mm");
    } else {
      return `${date.format(`DD/MM/${date.year() + 543}`)} ${date.format('HH:mm')} น.`;
    }
  }

  const columns = [
    {
      title: <div style={{ color: "#667085" }} className="text-table">{t('common.index')}</div>,
      dataIndex: "index",
      key: "index",
      render: (_, record, idx) => {
        return <span style={{ color: "#667085" }}>{(pagination.page - 1) * pagination.size + idx + 1}</span>;
      },
      key: "index",
      width: 100,
      align: "center",
    },
    {
      title: <div style={{ color: "#667085" }} className="text-table">{t('master_data.label.skill_type')}</div>,
      dataIndex: "commonTypeName",
      key: "commonTypeName",
      width: 150,
      sorter: (a, b) => a.commonTypeName.length - b.commonTypeName.length,
      render: (_, record) => {
        if (i18n.language === "en") {
          return <span style={{ color: "#667085" }}>{record.commonTypeNameEn}</span>;
        }
        return <span style={{ color: "#667085" }}>{record.commonTypeName}</span>;
      },
    },
    {
      title: <div style={{ color: "#667085" }} className="text-table">{t('master_data.label.description')}</div>,
      dataIndex: "description",
      key: "description",
      render: (_, record) => {
        if (i18n.language === "en") {
          return <span style={{ color: "#667085" }}>{record.descriptionEn}</span>;
        }
        return <span style={{ color: "#667085" }}>{record.description}</span>;
      },
    },
    // {
    //   title: <div style={{ color: "#667085" }} className="text-table">{t('master_data.label.payroll_data')}</div>,
    //   dataIndex: "payroll",
    //   key: "payroll",
    //   width: 150
    // },
    {
      title: <div style={{ color: "#667085" }} className="text-table">{t('master_data.label.last_modified')}</div>,
      dataIndex: "updateDate",
      key: "lastModified",
      sorter: (a, b) => {
        const { createBy = null, updateBy = null, updateDate, createDate } = a;
        return updateDate ? "updateDate" : "createDate"
      },
      width: 200,
      render: (_, record) => {

        const { createBy = null, updateBy = null, updateDate, createDate } = record;
        let lastModified = updateBy ?? createBy
        const name =
          i18n.language === "en" && lastModified.nameEn
            ? lastModified.nameEn + " " + lastModified.surNameEn
            : lastModified.name + " " + lastModified.surName;
        return (
          <span style={{ color: "#667085" }}>
            {name}
            <br />
            {formatDate(updateDate ?? createDate)}
          </span>
        );
      },

    },
    {
      title: <div style={{ color: "#667085" }} className="text-table">{t('master_data.label.status')}</div>,
      dataIndex: "statusFlag",
      key: "statusFlag",
      width: 100,
      align: "center",
      render: (text, record) => (
        <Switch
          checked={text === "ACTIVE"}
          onChange={(checked) => onStatus(checked, record)}
          disabled={roles.includes("UPDATE_CONFIGURATION|COMMON_MASTER|SKILL_TYPE") ? false : true}
        />
      ),
    },
    roles.includes("UPDATE_CONFIGURATION|COMMON_MASTER|SKILL_TYPE") ||
      roles.includes("DELETE_CONFIGURATION|COMMON_MASTER|SKILL_TYPE") ? {
      title: "",
      key: "action",
      width: 90,
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                roles.includes("UPDATE_CONFIGURATION|COMMON_MASTER|SKILL_TYPE") && {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                roles.includes("DELETE_CONFIGURATION|COMMON_MASTER|SKILL_TYPE") && {
                  key: "2",
                  onClick: () => onDelete(record),
                  label: `${t("action.delete")}`,
                  icon: (
                    <DeleteOutlined
                      style={{ fontSize: "18px", color: "gray" }}
                    />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    } : {},
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
      scroll={{ x: '1000px' }}
    />
  );
};

export default SkillTypeTable;
